import aika from "../../assets/combatants/underground/basic/aika.png";
import apollo from "../../assets/combatants/underground/basic/apollo.png";
import apple from "../../assets/combatants/underground/basic/apple.png";
import brooke from "../../assets/combatants/underground/basic/brooke.png";
import fumi from "../../assets/combatants/underground/basic/fumi.png";
import fuyuki from "../../assets/combatants/underground/basic/fuyuki.png";
import hana from "../../assets/combatants/underground/basic/hana.png";
import haruno from "../../assets/combatants/underground/basic/haruno.png";
import hono from "../../assets/combatants/underground/basic/hono.png";
import kazuko from "../../assets/combatants/underground/basic/kazuko.png";
import kikiray from "../../assets/combatants/underground/basic/kikiray.png";
import kumiko from "../../assets/combatants/underground/basic/kumiko.png";
import masao from "../../assets/combatants/underground/basic/masao.png";
import muu from "../../assets/combatants/underground/basic/muu.png";
import reta from "../../assets/combatants/underground/basic/reta.png";
import suigun from "../../assets/combatants/underground/basic/suigun.png";
import taku from "../../assets/combatants/underground/basic/taku.png";
import tama from "../../assets/combatants/underground/basic/tama.png";
import toye from "../../assets/combatants/underground/basic/toye.png";
import unasakaRyou from "../../assets/combatants/underground/basic/unasaka-ryou.png";
import wakame from "../../assets/combatants/underground/basic/wakame.png";
import yon from "../../assets/combatants/underground/basic/yon.png";
import yumi from "../../assets/combatants/underground/basic/yumi.png";
import zuima from "../../assets/combatants/underground/basic/zuima.png";

export default {
  Aika: {
    name: "Aika",
    description: "A cute wannabe cheeleader.",
    img: aika,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "small",
    eyeColor: "brown",
    hairColor: "blonde",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    // Pref properties effect 'AI'
    prefAttack: "tongue",
    prefTarget: "touch",
    uniqueAttackText: "Aika licks xxxx's body with a slobbering wet tongue",
    roughPlayLvl: 4, // how responds to domination either -hates or +likes
    // Prowess is capability
    seductionResistance: 15,
    grapplingProwess: 10,
    // sexual attack prowess
    tongueProwess: 20,
    touchProwess: 15,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 5,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Apollo: {
    name: "Apollo",
    description: "A beautiful & competent swimmer",
    img: apollo,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "full",
    eyeColor: "light purple",
    hairColor: "black",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText: "Apollo expertly fondle's xxxx's chest",
    roughPlayLvl: 14,
    seductionResistance: 15,
    grapplingProwess: 10,
    tongueProwess: 15,
    touchProwess: 20,
    cockProwess: 5,
    vaginaProwess: 10,
    anusProwess: 5,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 5,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Apple: {
    name: "Apple",
    description: "A sun loving, and lazy cutie",
    img: apple,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "full",
    eyeColor: "light brown",
    hairColor: "red",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "vagina",
    prefTarget: "mouth",
    uniqueAttackText:
      "Apple rides xxxx's face, soaking xxxx in her delicious pussy juices",
    roughPlayLvl: -10,
    seductionResistance: 5,
    grapplingProwess: 15,
    tongueProwess: 15,
    touchProwess: 20,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 15,
    touchResistance: 5,
    breastResistance: 20,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Brooke: {
    name: "Brooke",
    description: "A seductive little teen, who loves to run.",
    img: brooke,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "light blue",
    hairColor: "brunette",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "anus",
    prefTarget: "cock",
    uniqueAttackText:
      "Brooke rides xxxx's cock with her tight arse, gobbling it deep into her back passage",
    roughPlayLvl: 14,
    seductionResistance: 15,
    grapplingProwess: 10,
    tongueProwess: 20,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 20,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Fumi: {
    name: "fumi",
    description: "A synchronized swimming prodigy.",
    img: fumi,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "light blue",
    hairColor: "black",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "vagina",
    uniqueAttackText:
      "Fumi nervously suckles xxxx's clit, turning red as she tastes her warm pussy juices",
    roughPlayLvl: -15,
    seductionResistance: 15,
    grapplingProwess: 15,
    tongueProwess: 20,
    touchProwess: 10,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 5,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Fuyuki: {
    name: "Fuyuki",
    description: "A fashion obsessed socialite",
    img: fuyuki,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "hazel",
    hairColor: "pink",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "anus",
    uniqueAttackText:
      "Fuyuki's gentle hand drives a wave of pleasure as she presses xxxx's anal erogenous zone",
    roughPlayLvl: 10,
    seductionResistance: 15,
    grapplingProwess: 5,
    tongueProwess: 5,
    touchProwess: 20,
    cockProwess: 5,
    vaginaProwess: 10,
    anusProwess: 15,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 20,
    orgasmLimit: 2,
  },
  Hana: {
    name: "Hana",
    description:
      "A unreasonably sexy teacher, with a bad repution for sleeping with young female students.",
    img: hana,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "shapely",
    eyeColor: "aqua",
    hairColor: "grey",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "touch",
    uniqueAttackText:
      "Hana slides her dripping pussy all over xxxx's soft skin",
    roughPlayLvl: 14,
    seductionResistance: 15,
    grapplingProwess: 10,
    tongueProwess: 20,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 20,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Haruno: {
    name: "Haruno",
    description: "A powerful young shot putter.",
    img: haruno,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "small and tight",
    eyeColor: "brown",
    hairColor: "dark brown",
    skinColor: "tan",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "anus",
    prefTarget: "mouth",
    uniqueAttackText:
      "Haruno grinds her powerfully tight buttcheeks over xxxx's face",
    roughPlayLvl: -15,
    seductionResistance: 15,
    grapplingProwess: 15,
    tongueProwess: 20,
    touchProwess: 10,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 5,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Hono: {
    name: "Hono",
    description: "A seductive little demon-in-training",
    img: hono,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Demon",
    bodyShape: "petite",
    eyeColor: "maroon",
    hairColor: "orange",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 0,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "breasts",
    uniqueAttackText:
      "Hono uses her expertly trained tongue to tease xxxx's breasts",
    roughPlayLvl: 25,
    seductionResistance: 15,
    grapplingProwess: 5,
    tongueProwess: 25,
    touchProwess: 10,
    cockProwess: 5,
    vaginaProwess: 10,
    anusProwess: 5,
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Kazuko: {
    name: "Kazuko",
    description: "A shy young, dedicated schoolgirl.",
    img: kazuko,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "youthful",
    eyeColor: "light purple",
    hairColor: "black",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 0,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "cock",
    uniqueAttackText:
      "kazuko's nervous hands gently pump xxxx's cock, in a adorable and lovably shy way",
    roughPlayLvl: 14,
    seductionResistance: 15,
    grapplingProwess: 10,
    tongueProwess: 20,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 20,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Kikiray: {
    name: "Kikiray",
    description: "A seductive young sexual tease.",
    img: kikiray,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "full",
    eyeColor: "red",
    hairColor: "dark red",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "vagina",
    prefTarget: "vagina",
    uniqueAttackText:
      "Kikiray roughly scissors xxxx, expertly teasing her clit",
    roughPlayLvl: 15,
    seductionResistance: 5,
    grapplingProwess: 25,
    tongueProwess: 10,
    touchProwess: 10,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 5,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 15,
    orgasmLimit: 2,
  },
  Kumiko: {
    name: "Kumiko",
    description: "A bubbly young dance student",
    img: kumiko,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Demon",
    bodyShape: "youthful",
    eyeColor: "brown",
    hairColor: "brown",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "anus",
    prefTarget: "touch",
    uniqueAttackText:
      "Kumiko rubs her deliciously soft arse against xxxx's body",
    roughPlayLvl: 5,
    seductionResistance: 10,
    grapplingProwess: 20,
    tongueProwess: 25,
    touchProwess: 10,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 15,
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 15,
    orgasmLimit: 2,
  },
  Masao: {
    name: "Masao",
    description:
      "A busty teacher who lost her job by rewarding her class with a free for all bukkake.",
    img: masao,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "brown",
    hairColor: "black",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 4,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Masao pumps xxxx's cock, eagerly hoping to coat her mouth with fresh cum",
    roughPlayLvl: 20,
    seductionResistance: 15,
    grapplingProwess: 15,
    tongueProwess: 20,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 20,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 5,
    anusResistance: 10,
    orgasmLimit: 2,
  },
  Muu: {
    name: "Muu",
    description: "An affectionate young catgirl.",
    img: muu,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Catgirl",
    bodyShape: "full",
    eyeColor: "green",
    hairColor: "blonde",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 3,
    prefAttack: "touch",
    prefTarget: "touch",
    uniqueAttackText: "Muu rubs her body against xxxx's purring adorably",
    roughPlayLvl: -5,
    seductionResistance: 5,
    grapplingProwess: 20,
    tongueProwess: 15,
    touchProwess: 15,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 5,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 20,
    anusResistance: 15,
    orgasmLimit: 2,
  },
  Reta: {
    name: "Reta",
    description: "A busty tease, who loves attention.",
    img: reta,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "brown",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "breasts",
    uniqueAttackText: "Reta runs her slippery pussy lips over xxxx's breasts",
    roughPlayLvl: -10,
    seductionResistance: 20,
    grapplingProwess: 5,
    tongueProwess: 20,
    touchProwess: 10,
    cockProwess: 15,
    vaginaProwess: 20,
    anusProwess: 5,
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 5,
    orgasmLimit: 2,
  },
  Suigun: {
    name: "Suigun",
    description: "A supple and flirtatious aerobics enthusiast.",
    img: suigun,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "soft",
    eyeColor: "black",
    hairColor: "black",
    skinColor: "olive",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "anus",
    prefTarget: "vagina",
    uniqueAttackText:
      "Suigun reveals a dildo she inserts into her arse and uses to fuck xxxx's pussy",
    roughPlayLvl: 15,
    seductionResistance: 15,
    grapplingProwess: 20,
    tongueProwess: 15,
    touchProwess: 15,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 20,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 25,
    orgasmLimit: 2,
  },
  Taku: {
    name: "Taku",
    description: "A sultry young demon.",
    img: taku,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "toned",
    eyeColor: "orange",
    hairColor: "light grey",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 3,
    throatSize: 4,
    prefAttack: "tongue",
    prefTarget: "touch",
    uniqueAttackText:
      "Taku slathers xxxx's body with wet kisses and soft licks",
    roughPlayLvl: 10,
    seductionResistance: 10,
    grapplingProwess: 15,
    tongueProwess: 20,
    touchProwess: 10,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 5,
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 5,
    orgasmLimit: 2,
  },
  Tama: {
    name: "Tama",
    description: "A supple and flirtatious aerobics enthusiast.",
    img: tama,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "shapely",
    eyeColor: "gold",
    hairColor: "black",
    skinColor: "dark",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "mouth",
    uniqueAttackText:
      "Tama's soft dark skinned hands pleasurably explore xxxx's wet mouth",
    roughPlayLvl: -5,
    seductionResistance: 20,
    grapplingProwess: 10,
    tongueProwess: 15,
    touchProwess: 20,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 20,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 15,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 20,
    orgasmLimit: 2,
  },
  Toye: {
    name: "Toye",
    description: "A king and loving young teaching assistant.",
    img: toye,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "shapely",
    eyeColor: "brown",
    hairColor: "black",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "cock",
    uniqueAttackText:
      "Toye moans and bucks as she wriggles unconfidently on xxxx's hard cock",
    roughPlayLvl: 2,
    seductionResistance: 15,
    grapplingProwess: 10,
    tongueProwess: 15,
    touchProwess: 15,
    cockProwess: 5,
    vaginaProwess: 20,
    anusProwess: 10,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 5,
    orgasmLimit: 2,
  },
  UnasakaRyou: {
    name: "Unasaka Ryou",
    description: "An emotional but intelligent young student.",
    img: unasakaRyou,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "brown",
    hairColor: "brown",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "anus",
    prefTarget: "touch",
    uniqueAttackText:
      "Ryou softly runs along xxxx's skin with her squishy bottom",
    roughPlayLvl: -15,
    seductionResistance: 12,
    grapplingProwess: 15,
    tongueProwess: 20,
    touchProwess: 10,
    cockProwess: 12,
    vaginaProwess: 12,
    anusProwess: 10,
    touchResistance: 11,
    breastResistance: 10,
    mouthResistance: 16,
    cockResistance: 5,
    vaginaResistance: 12,
    anusResistance: 15,
    orgasmLimit: 2,
  },
  Wakame: {
    name: "Wakame",
    description: "An overconfident young bellydancer.",
    img: wakame,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "green",
    hairColor: "black",
    skinColor: "deep tan",
    height: 0,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "tongue",
    prefTarget: "anus",
    uniqueAttackText:
      "Wakame's long tongue enthusiastically explores xxxx's back passage",
    roughPlayLvl: -5,
    seductionResistance: 10,
    grapplingProwess: 10,
    tongueProwess: 20,
    touchProwess: 20,
    cockProwess: 5,
    vaginaProwess: 12,
    anusProwess: 16,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 5,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 14,
    orgasmLimit: 2,
  },
  Yon: {
    name: "Yon",
    description: "A shy gothic clothing fan.",
    img: yon,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "small",
    eyeColor: "brown",
    hairColor: "blonde",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 0,
    prefAttack: "touch",
    prefTarget: "vagina",
    uniqueAttackText:
      "Yon's delicate fingers, lovingly pleasure xxxx's dripping pussy",
    roughPlayLvl: -10,
    seductionResistance: 16,
    grapplingProwess: 14,
    tongueProwess: 15,
    touchProwess: 18,
    cockProwess: 8,
    vaginaProwess: 10,
    anusProwess: 12,
    touchResistance: 2,
    breastResistance: 12,
    mouthResistance: 18,
    cockResistance: 5,
    vaginaResistance: 14,
    anusResistance: 12,
    orgasmLimit: 2,
  },
  Yumi: {
    name: "Yumi",
    description: "a tomboy swimmer and general troublemaker.",
    img: yumi,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "youthful",
    eyeColor: "brown",
    hairColor: "brown",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "mouth",
    uniqueAttackText: "Yumi forces her sopping wet pussy onto xxxx's face",
    roughPlayLvl: 5,
    seductionResistance: 18,
    grapplingProwess: 15,
    tongueProwess: 10,
    touchProwess: 10,
    cockProwess: 12,
    vaginaProwess: 18,
    anusProwess: 12,
    touchResistance: 15,
    breastResistance: 8,
    mouthResistance: 16,
    cockResistance: 20,
    vaginaResistance: 12,
    anusResistance: 18,
    orgasmLimit: 2,
  },
  Zuima: {
    name: "Zuima",
    description: "An timid boulder climber and class rep.",
    img: zuima,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "purple",
    hairColor: "purple",
    skinColor: "light",
    height: 0,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "cock",
    uniqueAttackText:
      "Zuima gently rubs xxxx's cock over her budding breasts, moaning as it runs over her nipples",
    roughPlayLvl: 0,
    seductionResistance: 10,
    grapplingProwess: 10,
    tongueProwess: 8,
    touchProwess: 10,
    cockProwess: 5,
    vaginaProwess: 12,
    anusProwess: 16,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 5,
    cockResistance: 5,
    vaginaResistance: 10,
    anusResistance: 8,
    orgasmLimit: 2,
  },
};
